import { useCallback } from 'react';

import { NotificationOption } from '~/components/Notification';
import { useAppDispatch } from '~/store/hooks';
import { setOption } from '~/store/slices/notification';
import { getApiError } from '~/utils/helpers';

export const useNotification = () => {
  const dispatch = useAppDispatch();

  const showNotification = useCallback(
    (option: NotificationOption) => {
      dispatch(setOption(option));
    },
    [dispatch],
  );

  const handleApiError = useCallback(
    (error: unknown) => {
      const apiError = getApiError(error);

      let title: string;
      let message: string;

      if (apiError) {
        if ('title' in apiError.data) {
          title = apiError.data.title;
          message = apiError.data.message;
        } else {
          title = 'Unexpected Error';
          message = apiError.data.msg;
        }
      } else {
        title = 'Unexpected Error';
        message = 'Something went wrong. Please try again later.';
      }

      showNotification({
        type: 'error',
        title,
        message,
      });
    },
    [showNotification],
  );

  return { handleApiError, showNotification };
};
